import { useState, useEffect } from "react";
import { listActiveAnnouncements } from "../api/campaigns";

const UpdatesView = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listActiveAnnouncements()
      .catch(error => ({ data: null, error }))
      .then(({ data }) => { setAnnouncements(data || []); setLoading(false); });
  }, []);

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: "48px 24px" }} className="fade-up">
      <div style={{ marginBottom: 40 }}>
        <p style={{ fontFamily: "var(--font-mono)", fontSize: "11px", letterSpacing: "0.15em", color: "var(--amber)", textTransform: "uppercase", marginBottom: 10 }}>Updates &amp; Announcements</p>
        <h1 style={{ fontSize: "36px", letterSpacing: "-0.02em" }}>Latest News</h1>
      </div>
      {loading ? (
        <p style={{ fontFamily: "var(--font-mono)", fontSize: "12px", color: "var(--text-muted)", letterSpacing: "0.12em" }}>LOADING…</p>
      ) : announcements.length === 0 ? (
        <p style={{ color: "var(--text-dim)", fontSize: "15px" }}>No announcements yet. Check back soon.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {announcements.map((a, idx) => (
            <div key={a.id} style={{
              padding: "32px 0",
              borderTop: "1px solid var(--border)",
              borderBottom: idx === announcements.length - 1 ? "1px solid var(--border)" : "none",
              display: "grid", gridTemplateColumns: "180px 1fr", gap: 40,
            }}>
              <div>
                {a.tag && (
                  <span style={{ display: "inline-block", marginBottom: 10, fontFamily: "var(--font-mono)", fontSize: "10px", letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--amber)", background: "rgba(232,160,32,0.1)", padding: "3px 8px", borderRadius: 2 }}>{a.tag}</span>
                )}
                <p style={{ fontFamily: "var(--font-mono)", fontSize: "11px", color: "var(--text-muted)", lineHeight: 1.6 }}>
                  {new Date(a.published_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
                </p>
              </div>
              <div>
                <h3 style={{ fontSize: "22px", marginBottom: 12, lineHeight: 1.2 }}>{a.title}</h3>
                <p style={{ color: "var(--text-dim)", fontSize: "15px", lineHeight: 1.75 }}>{a.body}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UpdatesView;
